import { buildApiUrl } from '@/api/baseUrl';
import { getAccessToken } from '@/api/client';

// Thin analytics helper — wraps v1's tracker.send() as a named-event push.
// Matches the v2.0 pushEvent(type, userId?, metadata?) signature so v2.0 UI
// components can be imported unchanged.

async function send(eventType: string, userId?: string, metadata?: Record<string, unknown>) {
  try {
    await fetch(buildApiUrl('/app/analytics/event'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAccessToken() ?? ''}`,
      },
      body: JSON.stringify({
        event_name: eventType,
        user_id: userId,
        properties: metadata ?? {},
        timestamp: new Date().toISOString(),
      }),
      keepalive: true,
    });
  } catch {
    // analytics failures are always silent
  }
}

export function pushEvent(eventType: string, userId?: string, metadata?: Record<string, unknown>): void {
  void send(eventType, userId, metadata);
}
